<template>
  <div class="offprint">
    <div class="offprint-box">
      <!-- <el-tabs
        type="card"
        class="cart-box"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          :name="item.name"
          :label="item.name"
          v-for="(item, index) in goodsType"
          :key="index"
        >
        </el-tab-pane>
      </el-tabs> -->
      <div v-if="errorText === ''">
        <div v-if="success === 0" class="contentBox">
          <Header title="单行本领取"></Header>
          <div class="alertBox">
            <el-alert
              v-if="isRealIden === '0' || expression.length > 0"
              style="margin-bottom:20px;"
              :title="`尊敬的用户，您好！您正在领取《${ebProduct.name&& ebProduct.name != null ? ebProduct.name : ''}》，请您按照提示完成以下必要信息的填写，点击“下一步”进入领取确认页面。`"
              :closable="false"
              type="warning">
            </el-alert>
          </div>
          <div class="formBox" v-if="isRealIden === '0'">
            <div class="lineHeight">
              <span class="spanStyle">实名认证：</span>
              <span :class="[isAuthentication ? 'bgImg1' : 'bgImg']"></span>

              <span> {{ isAuthentication ? "已认证" : "未认证，" }}</span>
              <span
                class=" gotoAuthentication"
                style="cursor: pointer;"
                v-if="!isAuthentication"
                @click="goToRZ()"
                >点击前往认证</span
              >
            </div>
            <div
              class="lineHeight"
              v-if="roleStatus != 'failure' && orgList.role"
            >
              <span class="spanStyle">{{ orgList.role }}</span>
              <span :class="[roleStatus ? 'bgImg1' : 'bgImg']"></span>
              <span class="">
                <!-- <span
                style="width: 10px;height: 10px;border-radius: 50%;display: inline-block;"
                :style="{
                  background: !roleStatus ? '#A2EF4D ' : '#E99D42 '
                }"
              ></span> -->
                {{ roleStatus ? "已认证" : "未认证" }}</span
              >
            </div>
            <!-- <div class="orgListText" v-if="roleStatus === 'false' && orgList">
              <span class="spanStyle">医师用户：</span>
              <span>{{ orgList.role }}</span>
            </div> -->
          </div>
          <div class="formBox" style="border:none" v-if="expression.length > 0">
            <!-- <el-alert
              style="margin-bottom:20px;"
              :title="`尊敬的用户，您好！您正在领取《${ebProduct.name&& ebProduct.name != null ? ebProduct.name : ''}》，请您按照提示完成以下必要信息的填写，点击“下一步”进入领取确认页面。`"
              :closable="false"
              type="warning">
            </el-alert> -->
            <div v-for="(item, index) in expression" :key="index">
              <!-- 输入框 -->
              <div
                v-if="item.type === 'string'"
                class="lineHeight"
                style="margin-top:15px"
              >
                <span class="spanStyle"
                  >{{ item.name
                  }}{{ item.required ? "（必填）：" : "：" }}</span
                >
                <span class="floatRight"
                  ><el-input
                    class="input-input"
                    v-model="form[item.param]"
                    placeholder="请输入内容"
                    @change="setForm(item.param)"
                  ></el-input
                ></span>
              </div>
              <!-- 小数 -->
              <div
                v-if="item.type === 'decimal'"
                class="lineHeight"
                style="margin-top:15px"
              >
                <span class="spanStyle"
                  >{{ item.name
                  }}{{ item.required ? "（必填）：" : "：" }}</span
                >
                <span class="floatRight"
                  ><el-input
                    class="input-input"
                    v-model="form[item.param]"
                    placeholder="请输入内容"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                    @change="setForm(item.param)"
                  ></el-input
                ></span>
              </div>
              <!-- 整数 -->
              <div
                v-if="item.type === 'number'"
                class="lineHeight"
                style="margin-top:15px"
              >
                <span class="spanStyle"
                  >{{ item.name
                  }}{{ item.required ? "（必填）：" : "：" }}</span
                >
                <span class="floatRight"
                  ><el-input
                    class="input-input"
                    v-model.number="form[item.param]"
                    placeholder="请输入内容"
                    @change="setForm(item.param)"
                  ></el-input
                ></span>
              </div>
              <!-- 时间 -->
              <div
                v-if="item.type === 'time'"
                class="lineHeight"
                style="margin-top:15px"
              >
                <span class="spanStyle"
                  >{{ item.name
                  }}{{ item.required ? "（必填）：" : "：" }}</span
                >
                <span class="floatRight">
                  <el-date-picker
                    v-model="form[item.param]"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="setForm(item.param)"
                  >
                  </el-date-picker
                ></span>
              </div>
              <!-- 秒 -->
              <div
                v-if="item.type === 'second'"
                class="lineHeight"
                style="margin-top:15px"
              >
                <span class="spanStyle"
                  >{{ item.name
                  }}{{ item.required ? "（必填）：" : "：" }}</span
                >
                <span class="floatRight">
                  <el-date-picker
                    v-model="form[item.param]"
                    type="datetime"
                    placeholder="选择日期时间"
                    value-format="yyyy-MM-dd"
                    @change="setForm(item.param)"
                  >
                  </el-date-picker>
                </span>
              </div>
              <!-- 上传 -->
              <div
                v-if="item.type === 'file'"
                class="lineHeight"
                style="margin-top:15px;    height: 200px;display:flex"
                :style="{ height: imgId.length === 0 ? '200px' : '180px' }"
              >
                <span class="spanStyle"
                  >{{ item.name
                  }}{{ item.required ? "（必填）：" : "：" }}</span
                >
                <span class="floatRight">
                  <!-- {{imgId.length}} -->
                  <!-- <div style="margin-right:30px;position: relative;"> -->
                  <div
                    v-if="imgId.length === 0"
                    @click="setIndex(item.param)"
                    style="display: inline-block;"
                  >
                    <el-upload
                      list-type="picture-card"
                      :action="url()"
                      :headers="header"
                      :show-file-list="false"
                      :on-change="changeUpload"
                      :on-remove="handleRemove"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                      accept=".jpg,.jpeg,.png,.JPEG,.PNG"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <span
                      style="
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #AFB5C0;
                        line-height: 44px;cursor: pointer;"
                      >图片格式为jpg或png，文件大小不超过5MB</span
                    >
                  </div>

                  <div v-else style="position: relative;">
                    <img
                      style="width: 148px;height: 148px;"
                      :src="form1[item.param]"
                      alt=""
                    />
                    <i
                      class="el-icon-close"
                      style="position: absolute;left: 130PX;top: 5PX;cursor: pointer;"
                      @click="handleRemove(0)"
                    ></i>
                  </div>
                  <!-- </div> -->
                </span>
              </div>
            </div>
          </div>
          <div class="btnBox" style="text-align: center;">
            <div v-if="isRealIden !== '0'">
              <el-button
                class="btn"
                @click="drawDown"
                style="margin-bottom:10px"
                >下一步</el-button
              >
            </div>
            <div v-else>
              <el-button
                v-if="isAuthentication"
                class="btn"
                @click="drawDown"
                style="margin-bottom:10px"
                >下一步</el-button
              >
              <el-button
                v-else
                class="btn"
                style="margin-bottom:10px;background:#999;"
                >下一步</el-button
              >
            </div>

            <!-- <el-button class="btn">微信</el-button> -->
            <!-- <div
              class="radio"
              style="text-align: initial;display: flex;align-items: flex-end;"
            >
              <el-checkbox v-model="radio" label=""> </el-checkbox>
              <div>
                <span
                  style="display: inline-block;white-space: initial;line-height: 18px;"
                >
                  我已认真阅读并同意
                </span>
                <span
                  class="urlHover"
                  style="color: #52B8CC !important;"
                  @click="getProxy('3')"
                  >《中华医学会杂志社网络使用服务协议》、</span
                >
                <span
                  class="urlHover"
                  style="color: #52B8CC !important;"
                  @click="getProxy('2')"
                  >《中华医学会杂志社期刊会员协议》</span
                >
              </div>
            </div> -->
          </div>
        </div>
        <div v-if="success === 1" style="min-height:493px" class="contentBox">
          <Header title="单行本领取"></Header>
          <div class="formBox" style="width: 600px;border:none">
            <div class="lineHeight">
              <span class="spanStyle spanStyle2">商品编号：</span>
              <span class="floatRight">{{
                ebProduct.id && ebProduct.id != null ? ebProduct.id : "暂无"
              }}</span>
            </div>
            <div class="lineHeight">
              <span class="spanStyle spanStyle2">商品名称：</span>
              <span class="floatRight">{{
                ebProduct.name&& ebProduct.name != null ? ebProduct.name : "暂无"
              }}</span>
            </div>
            <div class="lineHeight">
              <span class="spanStyle spanStyle2">商品类型：</span>
              <span class="floatRight">{{ "电子单行本" }}</span>
            </div>
            <div class="lineHeight" v-if="ebProduct.note">
              <span class="spanStyle spanStyle2">发布者：</span>
              <div
                class="floatRight"
                style="display: inline-table;width: 469px;"
              >
                <div v-if="ebProduct.note">
                  {{ ebProduct.note && ebProduct.note != null  && ebProduct.note != ''? ebProduct.note : "暂无" }}
                </div>
              </div>
            </div>
            <div class="lineHeight" v-if="ebProduct.detailDesc">
              <span class="spanStyle spanStyle2">商品简介：</span>
              <div
                class="floatRight"
                style="display: inline-table;width: 469px;"
              >
                <div v-if="ebProduct.detailDesc">
                  {{ ebProduct.detailDesc&& ebProduct.detailDesc != null && ebProduct.description != ''?ebProduct.detailDesc:'暂无' }}
                </div>
              </div>
            </div>
            <div class="lineHeight" ebProduct.description>
              <span class="spanStyle spanStyle2">商品介绍：</span>
              <div
                class="floatRight"
                style="display: inline-table;width: 469px;"
              >
                <div
                  v-if="ebProduct.description&& ebProduct.description != null"
                  v-html="ebProduct.description&& ebProduct.description != null && ebProduct.description != ''?ebProduct.description:'暂无'"
                ></div>
              </div>
            </div>
          </div>
          <div class="btnBox" style="text-align: center;">
            <el-button class="btn btn2" @click="drawDown1" style="margin-bottom:10px"
              >确认领取</el-button
            >
            <!-- <el-button class="btn">微信</el-button> -->
            <!-- <div
            class="radio"
            style="text-align: initial;display: flex;align-items: flex-end;"
          >
            <el-checkbox v-model="radio" label=""> </el-checkbox>
            <div>
              <span
                style="display: inline-block;white-space: initial;line-height: 18px;"
              >
                我已认真阅读并同意
              </span>
              <span class="urlHover" @click="getProxy('3')"
                >《中华医学会杂志社网络使用服务协议》、</span
              >
              <span class="urlHover" @click="getProxy('2')"
                >《中华医学会杂志社期刊会员协议》</span
              >
            </div>
          </div> -->
          </div>
        </div>
        <div v-if="success === 2" class="contentBox" style="height:493px">
          <Header title="单行本领取"></Header>
          <div v-if="!isSuccess">
            <div
              class="line1"
              style="width: 225px;margin: 0 auto;display: flex;align-items: center;"
            >
              <span
                style="width: 20px;height: 20px;border-radius:50%;display: inline-block;background:rgb(82,196,26);text-align: center;"
                ><i style="color:#fff;font-size:16px" class="el-icon-check"></i
              ></span>
              <h3 style="font-size:14px;margin-left:10px">
                恭喜！获取成功。您可以：
              </h3>
            </div>
            <div
              class="line2"
              style="width: 225px;margin: 0 auto;    padding-left: 30px;"
            >
              <span style="color: #666;font-size: 14px;    line-height: 30px;"
                >- 前往查看
              </span>
              <span
                style="color: #666;font-size: 14px;    line-height: 30px;color: #52B8CC !important;"
                @click="gotoUrl()"
                class="hoverSpan"
                >详情页面</span
              >
            </div>
            <div
              class="line3"
              style="width: 225px;margin: 0 auto;    padding-left: 30px;"
            >
              <span style="color: #666;font-size: 14px;    line-height: 30px;"
                >- 前往个人中心 -</span
              >
              <span
                style="color: #666;font-size: 14px;    line-height: 30px;color: #52B8CC !important;"
                class="hoverSpan"
                @click="gotoUrl1"
              >
                合集集锦页面</span
              >
            </div>
          </div>
          <div v-else>
            <div style="width: 470px;margin: 0 auto;">
              <div style="display: flex;align-items: center;">
                <span
                  style="width: 20px;height: 20px;border-radius:50%;display: inline-block;background:rgb(255,170,51);    text-align: center;"
                  ><i
                    style="color:#fff;font-size:16px"
                    class="el-icon-close"
                  ></i
                ></span>

                <h3
                  style="margin-left:10px;font-size:14px;    line-height: 30px;"
                >
                  {{ commonApiMsg }}
                </h3>
              </div>

              <div
                v-for="(item, index) in roleList"
                :key="index"
                v-show="roleList.length > 0"
              >
                <span style="margin-left: 5px;display: inline-block;">{{
                  item.role
                }}</span>
              </div>
            </div>

            <div style="width: 225px;margin: 0 auto;    padding-left: 30px;">
              <span
                @click="gotoUrl2"
                style="color: #666;font-size: 14px;    line-height: 30px;color: #52B8CC !important;"
                class="hoverSpan"
              >
                返回试试
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        style="min-height:473px;text-align: center;
    line-height: 473px;
    font-size: 20px;
    font-weight: bold;"
      >
        {{ errorText }}
      </div>
    </div>
    <el-dialog
      class="dialog"
      :visible.sync="Dialog"
      width="30%"
      :before-close="handleClose"
    >
      <div class="modalWindow1" v-drag v-if="Dialog" style="width: 800px">
        <div class="modalWindow__top">
          <p class="modalWindow--txt1">
            {{ title }}
            <span class="modalWindow--close1" @click="Dialog = false"></span>
          </p>
        </div>
        <div
          class="content "
          style=" max-height: 600px;overflow: auto; padding: 20px;"
        >
          <span class="fontStyle3" v-html="text"> </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from "./headerTitle.vue";
import { Get, Post } from "@/api/axios";
import axios from "axios";
// import payPage from "./components/payPage.vue";
export default {
  components: { Header },
  data() {
    return {
      memberId: "",
      detailDesc: "",
      description: "",
      content: "",
      detail: null,
      isSuccess: true,
      success: 0,
      activeName: "获取单行本",
      goodsType: [{ name: "获取单行本", type: "MY" }],
      param: "",
      input: "",
      radio: false,
      ebProduct: {},
      expression: "",
      form: [],
      form1: [],
      text: "",
      Dialog: false,
      title: "",
      imgId: [],
      orgList: {},
      roleStatus: false,
      header: {
        authToken: sessionStorage.getItem("token")
      },
      fromText: "",
      isRealIden: 0,
      errorText: "",
      commonApiMsg: "",
      data: [],
      roleList: [],
      nickName: "",
      userPhone: "",
      isAuthentication: "",
      casLogin: "",
      service: ""
    };
  },
  mounted() {
    this.memberId = localStorage.getItem("memberId");
    this.getCasConfig();
    this.getuserId();
    this.$nextTick(() => {
      setTimeout(() => {
        this.adjustSpanWidth();
      }, 1000)
    })
    // if (this.memberId === null) {
    //   let url = encodeURIComponent(location.href);
    //   let codes =  window.location.protocol +  "//" +  window.location.host +  "/member/cas/auth?redirectUrl=" +  url;
    //   console.log(url, "app -url--Post");
    //   console.log(codes, "codes--Post");
    //   console.log(localStorage.getItem("casLogin") +  "?service=" + encodeURIComponent(codes), "跳转的地址 app--Post");
    //   location.href = localStorage.getItem("casLogin") +  "?service=" + encodeURIComponent(codes);
    // }

   

    // this.goSm();
  },
  computed: {
    // isAuthentication() {
    //   return this.$store.state.isAuthentication;
    // },
    bassMember() {
      return this.$store.state.bassMember;
    },
    memberInfo() {
      return this.$store.state.memberInfo;
    }
  },
  watch: {},
  methods: {
    adjustSpanWidth() {
      const $spans = $('.spanStyle');
      console.log($spans, '按谁')
      let isWidthGreaterThan80 = false;

      $spans.each((index, element) => {
        if ($(element).width() > 80) {
          isWidthGreaterThan80 = true;
          return false; // 跳出循环
        }
      });

      if (isWidthGreaterThan80) {
        $spans.width(126);
      } else {
        $spans.width(78);
      }
    },
    async getuserId(cookieUUID) {
      // let a = location.href.indexOf("uuid=") + 5;
      // let urls = location.href.substring(a, b);
      let urls = cookieUUID || this.getUrlParam("uuid");
      let data = [];
      // let b = location.href.indexOf("&jsessionid=");

      let params = {
        logintoken: urls
      };
      await Post("/member/index/getUserInfo", params, "isJson")
        .then(res => {
          data = res.data;
          console.log(data, "memberId");
          if (data && typeof data != "object") {
            this.memberId = data;
             this.getAuthentication();
          } else {
          }
        })
        .catch(err => {});
    },
    getCookie(cname) {
      console.log("获取cookie中的 uuid");
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    },
    // 获取后台配置的各个地址
    async getCasConfig() {
      let cookieUUID = this.getCookie("uuid");
      console.log(cookieUUID, "cookieUUID");
      if (
        location.href.indexOf("/thirdLogin") == -1 &&
        location.href.indexOf("bindThLogin") == -1
      ) {
        let url = "/member/spc/v1/allMemberInfo/getCasConfig.do";
        await Get(url).then(res => {
          this.casLogin = res.data.casLogin;
          console.log(this.casLogin, "casLogin");
          this.param = this.getUrlParam("param");
          console.log(this.param);
          if (this.param && this.memberId) {
            // this.param = this.param.replaceAll(" ", "+");
            this.param = this.param.replace(/ /g,'+');
            
            this.getDetail();
          } else {
            let url = location.href;
            console.log(url, "url单行本跳转");
            console.log(window.location.protocol, "window.location.protocol");
            console.log(window.location.host, "window.location.host");
            let codes =
              window.location.protocol +
              "//" +
              window.location.host +
              "/member/cas/auth?redirectUrl=" +
              url;
            console.log(codes, "codes单行本跳转");
            console.log(this.casLogin + "?service=" + codes, "最终跳转地址");
            // location.href = this.casLogin + "?service=" + codes;
          }

          console.log(this.param, "param");
        });
      } else {
        // 第三方登录不需要这些
      }
    },
    async getDetail(data) {
      // loginProviderId 用于获取第三方用户信息的id
      if (localStorage.getItem("loginProviderId")) {
        localStorage.removeItem("loginProviderId");
        // return false;
      }
      let id = data || this.memberId;
      if (id) {
        await Post(
          "/member/spc/v1/allMemberInfo/getMemberDetail.do?userId=" + id
        ).then(res => {
          if (res.status == 0) {
            if (res.data.content[0].bassMember) {
              this.nickName = res.data.content[0].bassMember.nickName;
              this.userPhone =
                res.data.content[0].bassMember.mobile ||
                res.data.content[0].memberInfo.spareMobileNo;
              console.log(this.userPhone, "userPhoneuserPhone");
              this.drawDown1("start");
              if (this.memberId && this.param !== "") {
                this.getFromData();
              }
            }
          }
        });
      } else {
      }
    },
    // goSm() {
    //   Get(
    //     "/member/spc/" +
    //       window.version +
    //       "/authentication/find?type=2&orgCode=REAL_NAME" +
    //       "&userId=" +
    //       this.memberId
    //   ).then(res => {});
    // },
    //认证信息
    getAuthentication() {
      this.loading = true;
      if (location.href.indexOf("loginProviderId") != -1) {
        return false;
      }
      let url = `/member/spc/${this.$version}/authentication/find`;
      let params = {
        userId: this.memberId || localStorage.getItem("memberId"),
        type: 2,
        orgCode: "REAL_NAME"
      };
      Get(url, params).then(res => {
        if (res.status === 0) {
          this.detail = res.data && res.data[0] ? res.data[0] : [];
          if (this.detail && this.detail.checkState) {
            this.$store.commit("updateState", {
              key: "checkState",
              value: this.detail.checkState
            });
          }
          if (
            (this.detail && this.detail.checkState === 1) ||
            (this.detail && this.detail.checkState === 2)
          ) {
            this.$store.commit("updateState", {
              key: "isAuthentication",
              value: "true"
            });
            this.isAuthentication = true;
          } else if (
            (this.detail && this.detail.checkState === 3) ||
            (this.detail && this.detail.checkState === 4)
          ) {
            this.$store.commit("updateState", {
              key: "isAuthentication",
              value: "false"
            });
            this.isAuthentication = false;
          } else if (this.detail && this.detail.checkState === 0) {
            this.$store.commit("updateState", {
              key: "isAuthentication",
              value: "审核中"
            });
            this.isAuthentication = "审核中";
          } else {
            this.$store.commit("updateState", {
              key: "isAuthentication",
              value: ""
            });
            this.isAuthentication = "";
          }
          if (this.detail && this.detail.credentialsType) {
            this.$store.commit("updateState", {
              key: "IDtype",
              value: this.detail.credentialsType
            });
          }
          if (this.detail && this.detail.credentialsCode) {
            this.$store.commit("updateState", {
              key: "IDcard",
              value: this.detail.credentialsCode
            });
          }
        } else {
          // this.$message({
          //   message: "网络错误!",
          //   type: "error"
          // });
        }
      });
    },
    setForm(type) {
      let arr = [];
      let obj = {};
      obj[type] = this.form[type];
      this.data.push(obj);
      console.log(this.data, "data", this.form);
      this.data.forEach((element, ind) => {
        console.log(element, "element");
        console.log(Object.keys(element)[0], "keykey");
        if (Object.keys(element)[0] === type) {
          console.log("相同");
          arr.push(ind);
        }
      });

      arr.forEach((element, ind) => {
        if (element !== arr[arr.length - 1]) {
          this.data.splice(element, 1);
        }
      });
      console.log(arr, "arr");
      console.log(this.data, "data处理后");
      // let obj1 = {};
      // for (let i = 0; i < this.data.length; i++) {
      //   let item = this.data[i];
      //   if (obj1[item] !== undefined) {
      //     this.data.splice(i, 1);
      //     i--; // 解决删除元素后，数组塌陷问题
      //     continue;
      //   }
      //   obj1[item] = item;
      // }

      localStorage.setItem("form", JSON.stringify(this.data));
    },

    gotoUrl2() {
      this.success = 0;
    },
    gotoUrl1() {
      this.$router.push({
        path: "/personal",
        query: {
          nowNav: "compilation",
          activeName: "我的"
        }
      });
    },
    gotoUrl() {
      window.open(
        // `https://www.medjournals.cn/clinic/getClinicList.do?subjectId=${this.ebProduct.thridIden}`
        this.ebProduct.resourceLink
      );
    },
    goToRZ() {
      this.$router.push({
        path: "/personal",
        query: {
          nowNav: "basicInfo",
          isRZ: true,
          param: this.param,
          form: JSON.stringify(this.form, "form"),
          foreignApprove: "0"
        }
      });
      // let Link = this.$router.resolve({
      //   path: "/personal",
      //   query: {
      //     nowNav: "basicInfo",
      //     isRZ: true,
      //     param:this.param,
      //     form:JSON.stringify(this.form,'form'),
      //   }
      // });
      // window.open(Link.href, "_blank");
    },
    drawDown() {
      // if (!this.isAuthentication) {
      //   this.$message.warning("请进行实名认证");
      //   return;
      // }
      // if (!this.radio) {
      //   this.$message.warning("请阅读协议");
      //   return;
      // }
      for (let index = 0; index < this.expression.length; index++) {
        const element = this.expression[index];
        console.log(element, "element");
        for (const key in element) {
          if (
            element["required"] &&
            (this.form[element["param"]] == "" ||
              typeof this.form[element["param"]] == "undefined")
          ) {
            this.$message.error("请输入" + element["name"]);
            return;
          }
        }
      }
      this.success = 1;
    },
    drawDown1(type) {
      console.log(this.bassMember, "bassMember");
      let params = {
        status: type === "start" ? 0 : 1,
        userId: this.memberId,
        link: this.param,
        userName: this.nickName,
        userPhone: this.userPhone,
        ...this.form
        // param: JSON.parse(localStorage.getItem("form"))
      };
      console.log(this.userPhone, "this.userPhone");
      const form = JSON.parse(localStorage.getItem("form"));
      for (let i in form) {
        params = {
          ...this.form,
          ...params,
          ...form[i]
        };
      }

      // if (form !== []) {
      let url = "/neweb-product/" + this.$version + "/CommonApi";
      axios({
        method: "post",
        url: url,
        data: params,
        headers: {
          QueryType: "eqcode_access"
        }
      }).then(res => {
        if (type !== "start") {
          this.success = 2;
        }

        if (res.data.code === "0" || res.data.code === 0) {
          // this.$message.success("领取成功");
          this.isSuccess = false;
        } else {
          this.commonApiMsg =
            typeof res.data.data === "string" ? res.data.data : res.data.msg;

          if (res.data.code === 50006) {
            this.roleList = res.data.data;
          }
          this.isSuccess = true;
        }
      });
      // }
    },
    setIndex(ind) {
      this.fromText = ind;
    },
    handleRemove(index) {
      console.log(this.imgId, "this.imgId");
      console.log(index, "index");
      // this.imgList[index].img = "";
      // this.imgId[index] = ''
      this.form[this.fromText] = "";
      this.imgId = [];
      console.log(this.imgId, "this.imgId");
    },
    // 图片上传成功
    async handleAvatarSuccess(res, file) {
      console.log(res.data, "res.data");
      this.fileIds = res.data.ID;
      console.log(res.data.ID, " res.data.ID");
      this.imgId.push(res.data.ID);
      // this.form1.imId = this.imgId;
      if (res && res.data && res.data.ID) {
        let url = "/member/spc/v1/files/getFilePath?recordId=" + res.data.ID;
        await Get(url).then(res => {
          if (res.data.filePath) {
            this.$set(this.form, this.fromText, res.data.ID || this.imgId[0]);
            this.$set(this.form1, this.fromText, res.data.filePath);
            this.$forceUpdate();
            this.$message.success("上传成功");
            console.log(this.imgId, "imgId");
            console.log(this.form, "form");
          } else {
          }
        });
      }
    },
    url() {
      let url = "/member/spc/v1/files/fileUpload";
      return url;
    },
    changeUpload(file, fileList) {
      console.log(file.raw.type, "file");
      // this.imgSta = true;
      let isLt2MBs = file.size / 1024 / 1024 < 1;
      if (!isLt2MBs) {
        return false;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = event => {
          // console.log(event.target.result,'event.target.result');
          this.imgSrc = event.target.result;
        };

        reader.readAsDataURL(file.raw);
        // this.cropperOpen();
      } else {
        alert("Sorry, FileReader API not supported");
      }

      const isLt2MB = file.size / 1024 / 1024 < 5;
      if (!isLt2MB) {
        this.$message.error("上传文件大小不能超过 5MB!");
        return false;
      }
      this.fileinfo = file;

      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        localStorage.setItem("form", JSON.stringify(this.form));
        // this.option.img = file.data;
        // this.postImg(file);
      });
    },
    beforeAvatarUpload(res, file) {
      let isLt2MBs = res.size / 1024 / 1024 < 5;
      let s = "";
      if (!isLt2MBs) {
        this.$message.error("上传文件大小不能超过 5MB!");
        s = false;
      }
      return s;
    },
    // // 图片上传成功
    handleClose() {
      this.Dialog = false;
    },
    handleClick() {},
    getUrlParam(name) {
      //构造一个含有目标参数的正则表达式对象
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      //匹配目标参数
      var r = window.location.search.substr(1).match(reg);
      //返回参数
      if (r != null) {
        return unescape(r[2]);
      } else {
        return null;
      }
    },
    getFromData() {
      let url = "/neweb-product/" + this.$version + "/CommonApi";
      axios({
        method: "post",
        url: url,
        data: { link: this.param, userId: this.memberId },
        headers: {
          QueryType: "product_batch"
        }
      }).then(res => {
        console.log(res, "res");
        console.log(typeof res.data.data);
        console.log(res.data.code, "res.data.code ");
        if (res.data.code === 0) {
          this.ebProduct = res.data.data.ebProduct;
          this.expression = JSON.parse(res.data.data.expression);
          this.isRealIden = res.data.data.isRealIden;
          this.orgList = res.data.data.orgList || res.data.data.roleList || {};
          this.roleStatus =
            res.data.data.roleStatus === "failure"
              ? res.data.data.roleStatus
              : Boolean(JSON.parse(res.data.data.roleStatus));

          this.detailDesc;
        } else {
          this.errorText = res.data.data;
          // this.success = 2
          // this.isSuccess = true
          // this.$message.error(res.data.data);
          console.log(this.errorText);
        }
        console.log(this.expression, "expression");
        console.log(this.orgList, "orgList");
        console.log(this.isRealIden, "isRealIden");

        this.expression.forEach(element => {
          this.$set(this.form, element.param, "");
        });
        console.log(this.form, "form123444");
        if (this.$route.query.form) {
          if (
            localStorage.getItem("form") &&
            localStorage.getItem("form") != ""
          ) {
            let data = JSON.parse(localStorage.getItem("form"));

            data.forEach(element => {
              console.log(Object.keys(element), "element.keys()");
              this.form[Object.keys(element)] = element[Object.keys(element)];
              this.form1[Object.keys(element)] = element[Object.keys(element)];
            });
            // this.form = JSON.parse(localStorage.getItem("form"));
            // this.form1 = JSON.parse(localStorage.getItem("form"));
            console.log(this.form, "this.form");
            console.log(localStorage.getItem("form"), "this.$route.query.form");
          }
        }
      });
    },
    getProxy(value) {
      let params = {
        type: value
      };
      Post(
        `/member/spc/${window.version}/SpcMemberCancel/getProxy`,
        params,
        "isJson"
      )
        .then(res => {
          console.log(res, "res");
          if (res.data.content) {
            this.text = res.data.content;
            this.Dialog = true;
            if (value === "3") {
              this.title = "中华医学会杂志社网络使用服务协议";
            } else {
              this.title = "中华医学会杂志社期刊会员协议";
            }
          }
        })
        .catch(err => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.hoverSpan {
  cursor: pointer;
  &:hover {
    color: #52b8cc !important;
  }
}
.input-input {
  .el-input {
    width: 400px;
    margin-right: 6px;

    // margin-bottom: 15px;
    input {
      height: 40px;
      background-color: #f5f7f7;
      border: none;
      border-radius: 0;
    }
  }
}
.offprint-box {
  .bgImg {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url("../../assets/img/going.png") no-repeat center left;
    background-size: 20px;
    position: relative;
    top: 5px;
  }
  .bgImg1 {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url("../../assets/img/success.png") no-repeat center left;
    background-size: 20px;
    position: relative;
    top: 5px;
  }
  .spanStyle {
    min-width: 120px;
    text-align: end;
    display: inline-block;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
  }
  .spanStyle2 {
    line-height: 30px;
  }
  background: #fff;
  .gotoAuthentication {
    &:hover {
      color: #52b8cc;
    }
  }
  .content {
  }
  .urlHover {
    cursor: pointer;
    &:hover {
      color: #52b8cc;
    }
  }
  .dialog /deep/ .el-dialog__header {
    display: none;
  }

  .dialog /deep/ .el-dialog__body {
    padding: 0;
  }
  .floatRight {
    // float: right;
  }
  .contentBox {
    // padding: 40px 425px 0px 425px;
    padding-top: 40px;
    margin: 0 auto;
    width: 1100px;
    background-color: #fff;
    min-height: 473px;
    /deep/ .header-title .headerDiv .header {
      background: #52b8cc;
    }
  }

  .lineHeight {
    line-height: 30px;
    display: flex;
    flex-wrap: wrap;
    /deep/ img {
      max-width: 100%;
    }
  }

  // background: #fff;
  /deep/ .el-tabs {
    .el-tabs__header {
      background: #e6e9eb;
      margin-bottom: 0px;
      border-radius: 4px 4px 0 0;
      .el-tabs__nav {
        float: none;
        border: none;
        .el-tabs__item {
          width: 125px;
          text-align: center;
          height: 54px;
          line-height: 54px;
          color: #737a80;
          font-weight: bold;
          border-left: none;
          &:hover {
            color: #52b8cc !important;
          }
        }
        .el-tabs__item.is-active {
          background: #fff;
          border-radius: 4px 4px 0 0;
          color: #52b8cc;
        }
      }
    }
  }
  .table-box {
    background: #fff;
    padding: 20px 20px;
    overflow: initial;
  }
  .alertBox {
    margin: 0 auto;
    width: 708px;
  }
  .formBox {
    margin: 0 auto;
    width: 708px;
    padding-bottom: 20px;
    border-bottom: 1px dashed #bbbbbb;
    /deep/ .el-input__inner {
      height: 40px !important;
      width: 360px !important;
      border: none;
      background-color: #f5f7f7;
    }
    /deep/ .el-input__icon {
      line-height: 30px !important;
    }
    /deep/ .el-date-editor {
      width: 360px !important;
    }
    /deep/ .el-input {
      width: auto;
    }
  }
  .btnBox {
    margin: 0 auto;
    padding-top: 30px;
    width: 60%;
    padding-bottom: 10px;
    
    .btn {
      border: none;
      // width: 100px;
      height: 34px;
      border-radius: 20px;
      background-color: #52b8cc;
      font-size: 16px;
      line-height: 10px;
      color: #fff;
      cursor: pointer;
      text-align: center;
      margin: auto;
      &:hover {
        opacity: 0.8;
      }
    }
    .btn2 {
      position: fixed;
      bottom: 40%;
      left: 50%;
      transform: translateX(-50%);
    }
    /deep/ .el-checkbox__label {
      font-size: 12px;
      white-space: unset;
    }
    /deep/ .el-checkbox__inner {
      top: 0px;
      right: 5px;
      border-radius: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/offprint.vue